// DBLN Description Accordion + FAQ collapsible fix
(function() {

  // 1. FAQ — capture phase, registered FIRST
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.faq__question[data-action="toggle-collapsible"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var item = btn.closest('.faq__item');
    if (!item) return;
    var wrapper = item.querySelector('.faq__item-wrapper');
    var answer = item.querySelector('.faq__answer-wrapper');
    var isOpen = item.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      item.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-expanded', 'false');
      if (wrapper) wrapper.style.setProperty('height', 'auto', 'important');
    } else {
      item.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-expanded', 'true');
      if (wrapper) {
        var btnHeight = btn.offsetHeight;
        var answerHeight = answer ? answer.scrollHeight : 0;
        wrapper.style.setProperty('height', (btnHeight + answerHeight) + 'px', 'important');
      }
    }
  }, true);

  // 2. Description accordion — capture phase
  document.addEventListener('click', function(e) {
    var h3 = e.target.closest('h3.db-acc-h3');
    if (!h3) return;
    e.stopImmediatePropagation();
    var isOpen = h3.classList.toggle('db-open');
    var next = h3.nextElementSibling;
    while (next && next.tagName !== 'H3') {
      next.style.setProperty('display', isOpen ? '' : 'none', 'important');
      next = next.nextElementSibling;
    }
  }, true);

  // 3. Init description accordion structure
  function initDescAccordion() {
    document.querySelectorAll('[data-desc-accordion]').forEach(function(container) {
      if (container.dataset.dbAccInit === '1') return;
      container.dataset.dbAccInit = '1';
      var children = Array.from(container.children);
      var firstH3Index = children.findIndex(function(el) { return el.tagName === 'H3'; });
      if (firstH3Index === -1) return;
      children.forEach(function(el, i) {
        if (i < firstH3Index) return;
        if (el.tagName === 'H3') {
          el.classList.add('db-acc-h3');
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
        } else {
          el.style.setProperty('display', 'none', 'important');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescAccordion);
  } else {
    initDescAccordion();
  }

  window.addEventListener('load', initDescAccordion);

})();
